import React, {
    ReactElement,
} from 'react';

import { OzIcon, ICON_TYPE, ICON_SIZE } from '../../Icon/Icon.component';

import { collapseIconDisplayName } from './CollapseIcon.qa';

export interface ICollapseIconProps {
    'data-testid'?: string;
}

export function OzCollapseIcon (props: ICollapseIconProps): ReactElement {
    const {
        'data-testid': dataTestId = '',
    }: ICollapseIconProps = props;

    return (
        <OzIcon
            className='inline-block ml-1/2'
            data-testid={dataTestId}
            type={ICON_TYPE.OZ_ARROW_UP}
            size={ICON_SIZE.SMALL}
            alt={'Arrow-Up Icon'}
        />
    );
}

OzCollapseIcon.displayName = collapseIconDisplayName;
